module.exports = __webpack_public_path__ + "logo.svg?665b23c150be911b6c6f91e477187dd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 91
// module chunks = 0